
  <button *ngIf='!isRestrictedUser' mat-stroked-button  (click)='gotoBackPage()' class="table_head_back mt-3"><img
    src="assets/images/left.png" > Back</button>

<div class="wizard form_wizard my-3">
  <mat-tab-group [selectedIndex]="selectedIndex" >
    <mat-tab label="Personal Details" class="pos-rel tab_title" *ngIf="tabvisBusTab == 0">
      <div class="row m-0 form_left">
        <div class="col-sm-12 com-md-10 col-lg-10 col-xl-10 usertab">
          <form class="" [formGroup]='PersonalDetails'>
            <div class="col-12">
            <div class="profile_pic_container">
              <img [src]="imgsrc">
              <div class="profile_overlay" (click)='addPhoto()' >
                <p>Change</p>
              </div>

            </div>
              <div class="row ">
                <div class="col-12 my-3 p-0 wiz_title">
                  <span class="Badge">
                    <p>1</p>
                  </span>
                  <span>
                  Personal Profile Details
                  </span>
                </div>
                <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                  <mat-form-field class="col-12">
                    <input matInput placeholder="First Name" name="First Name" required formControlName="user_first_name">
                    <mat-error *ngIf="PersonalDetails.controls.user_first_name.invalid">Enter your First Name
                    </mat-error>
                  </mat-form-field>
                </div>
                <!-- <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                  <mat-form-field class="col-12">
                    <input matInput placeholder="Middle Name" formControlName="user_middle_name">

                  </mat-form-field>
                </div> -->
                <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                  <mat-form-field class="col-12">
                    <input matInput placeholder="Last Name" formControlName="user_last_name">
                    <mat-error *ngIf="PersonalDetails.controls.user_last_name.invalid">Enter your Last Name</mat-error>
                  </mat-form-field>
                </div>
                <div class="col-sm-12 com-md-6 col-lg-6 col-xl-6">
                  <mat-form-field class="col-12">
                    <input  matInput placeholder="User ID" formControlName='user_acno'>
                  </mat-form-field>
                </div>
                <div class="col-sm-12 com-md-6 col-lg-6 col-xl-6">
                  <mat-form-field class="col-12">
                    <input type="email" matInput placeholder="Business Email" formControlName='user_email'>
                    <mat-error *ngIf="PersonalDetails.controls.user_email.invalid">Enter a valid Email</mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </form>
          <form [formGroup]='AddressDetails'>
            <div class="col-12">
              <div class="row ">
                <!-- <div class="col-12 my-3 p-0 wiz_title">
                  <span class="Badge">2</span>
                  <span>
                    Residence Address
                  </span>
                </div>
                <div class="col-sm-12 com-md-2 col-lg-2 col-xl-2">
                  <mat-form-field class="col-12">
                    <mat-select placeholder="Country"  formControlName='country' required>
                      <mat-option *ngFor="let item of country" [value]="item.bt_country_id">
                        {{item.name}}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="AddressDetails.controls.country.invalid">Select a country</mat-error>
                  </mat-form-field>
                </div>
                <div class="col-sm-12 com-md-2 col-lg-2 col-xl-2">
                  <mat-form-field class="col-12">
                    <input matInput placeholder="Zip Code" required formControlName='user_zip_code' (change)='findZip()'>
                    <mat-error *ngIf="AddressDetails.get('user_zip_code').errors?.validZip">Enter a valid zip code
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-sm-12 com-md-2 col-lg-2 col-xl-2">
                  <mat-form-field class="col-12">
                    <input disabled matInput placeholder="State" disabled formControlName='state'>
                    <mat-error *ngIf="AddressDetails.get('state').errors?.required">Enter State</mat-error>
                  </mat-form-field>
                </div>
                <div class="col-sm-12 com-md-3 col-lg-3 col-xl-3">
                  <mat-form-field class="col-12">
                    <input matInput placeholder="County" formControlName='county'>
                    <mat-error *ngIf="AddressDetails.get('county').errors?.required">Enter your county</mat-error>
                  </mat-form-field>
                </div>
                <div class="col-sm-12 com-md-3 col-lg-3 col-xl-3">
                  <mat-form-field class="col-12">
                    <input matInput placeholder="City" formControlName='city'>
                    <mat-error *ngIf="AddressDetails.get('city').errors?.required">Enter City</mat-error>
                  </mat-form-field>
                </div> -->
                <!-- <div class="col-sm-12 com-md-3 col-lg-3 col-xl-3">
                  <mat-form-field class="col-12"> 
                    <input type="text" matInput placeholder="Street Number" formControlName='street_number' required>
                    <mat-error *ngIf="(AddressDetails.get('street_number').errors?.required ||
                    AddressDetails.get('street_number').errors?.invalidStreetNum ||
                    AddressDetails.get('street_number').errors?.isFullSpace
                     ) &&
                  !AddressDetails.get('street_number').errors?.maxlength
                  ">Enter valid Street Number
                    </mat-error>
                    <mat-error *ngIf="AddressDetails.get('street_number').errors?.maxlength">
                      Maximum length of street number should be
                      {{AddressDetails.get('street_number').errors.maxlength.requiredLength}}
                    </mat-error>
                  </mat-form-field>
                </div> -->
                <!-- <div class="col-sm-12 com-md-2 col-lg-2 col-xl-2">
                  <mat-form-field class="col-12">
                    <input matInput placeholder="Street Name" formControlName='street_name' required>
                    <mat-error *ngIf="AddressDetails.controls.street_name.invalid">Enter Street Name</mat-error>
                  </mat-form-field>
                </div>
                <div class="col-sm-12 com-md-2 col-lg-2 col-xl-2">
                  <mat-form-field class="col-12">
                    <input matInput placeholder="Unit" formControlName='unit'>
                  </mat-form-field>
                </div> -->
                <div class="col-sm-12 com-md-3 col-lg-3 col-xl-3">
                  <mat-form-field class="col-12">
                    <input matInput placeholder="Phone Number" formControlName='cell_number' mask="(000) 000-0000" required
                      [showMaskTyped]="true">
                    <mat-error>Enter a valid Phone Number
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-sm-12 com-md-2 col-lg-2 col-xl-2">
                  <mat-form-field class="col-sm-12">
                    <mat-select placeholder="Phone Type" formControlName="phone_type_id" required>
                      <mat-option *ngFor="let item of phoneTypeList" [value]='item.bt_phone_type_id'>
                        {{item.name}}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="AddressDetails.get('phone_type_id').errors?.required">Enter Contact Person's Phone
                      Type</mat-error>
                  </mat-form-field>

              <div class="col-sm-12" *ngIf="phoneTypeName == 'Mobile'">
                <p class="sms_opt">SMS Notification  </p>
                <div class="d-flex align-items-center">
                <span class="sms_opt sms_opt_option1">Disable</span>
               <mat-slide-toggle formControlName="sms_opt_in_out" [disabled]="!edit"></mat-slide-toggle>
               <span class="sms_opt sms_opt_option2">Enable</span>
                </div>
                </div>
                </div>
                <!-- <div class="col-12">
                  <mat-checkbox formControlName="is_correct_zip" [value] ='is_correct_zip' (change)='AddressDetailsIncorrectZip($event)'
                    class="col-12">Edit state, county , city details ?
                  </mat-checkbox>
                </div> -->
              </div>
            </div>
          </form>
        </div>
        <div class="col-sm-12 com-md-2 col-lg-2 col-xl-2 tabnavbg">
          <div class="options_selector row h-100 justify-content-center">
            <div class="extender"></div>

            <div class=" fed_backwd_group row w-100">
              <div class="tabbutton  col-12 pr-0">
                <button mat-raised-button color="primaryCus" (click)='enableDisable(true)' *ngIf="!edit"
                  class="frwd_button control_buttons  col-5 mr-2">Edit</button>
                <button mat-raised-button color="primaryCus" (click)='saveData()' *ngIf="edit"
                  class="frwd_button control_buttons  col-5 mr-2">Save</button>
                <button mat-raised-button color="primaryStrCus" (click)='cancelEdit()' *ngIf="edit"
                  class="frwd_button control_buttons  col-6">Cancel</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>
    </mat-tab-group>
    </div>
